import React, { useState, useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from "react-redux";
// import Fade from 'react-reveal/Fade'
import FormAction from './formAction'
import csc from 'country-state-city'

function Residency (props){
  
  const [state, setState] = useState({
    formData: {
      percent_completed: 25,
      is_international_applicant:'',
      is_english_second:'',
      is_citizen:'',
      country_of_residence:''
    },
    is_international_applicantValid: '',
    is_english_secondValid: '',
    is_citizenValid: '',
    country_of_residenceValid: '',
    isFormDataValid: false
  })

  const allCountries = csc.getAllCountries();

  const { savedSteps, selectedProgramId, selectedProgramLabel } = useSelector((state) => ({
    savedSteps: state.applicationReducer.savedSteps,
    selectedProgramId: state.applicationReducer.selectedProgramId,
    selectedProgramLabel: state.applicationReducer.selectedProgramLabel
  }), shallowEqual);

  useEffect(()=>{
    window.scrollTo(0, 0)
    if (!!savedSteps.residency) {
      populateForm();
    }
  },[])

  useEffect(()=>{
    validateForm();
  },[state])

  function populateForm(){
    const residencyData = savedSteps.residency;
    if (!!savedSteps.residency && Object.keys(residencyData).length > 0) {
      updateForm('is_international_applicant', residencyData.is_international_applicant)
      updateForm('is_english_second', residencyData.is_english_second)
      updateForm('is_citizen', residencyData.is_citizen)
      updateForm('country_of_residence', residencyData.country_of_residence)
    }
  }

  const updateForm = (field, value) => {
    let temp = state.formData
    temp[field] = value
    setState(prevState => ({ ...prevState, formData: temp }));
    _validate(field)
  }
  const _validate = (field) => {
    let regex, valid;
    let value = state.formData[field];
    switch(field){
      case 'country_of_residence':
        valid = true;
        break;
      case 'is_international_applicant': case 'is_english_second': case 'is_citizen': 
        regex = /^.{1,}/;
        valid = regex.test(value)
        break;
    }
    setState(prevState => ({ ...prevState, [field+"Valid"]: valid }));
  }

  const validateForm = () => {
    let formData = state
    let form = !!formData.is_international_applicantValid && !!formData.is_english_secondValid && !!formData.is_citizenValid
    if (state.isFormDataValid != form) {
      setState(prevState => ({ ...prevState, isFormDataValid: form }));
    }
  }


  return(
    <>
      	<div className="app-form-container residency">

      		<div className="main-heading bayan-main-heading">
            {selectedProgramLabel}
          </div>
          <div className="sub-heading app-info">
            Residency
          </div>
          <div className="form-content">
            <div className="input-group">
              <div className="field-label">Are you an international applicant? *</div>
              <div className="inline-radio">
                <div className={`radio-options`}>
                  <div className={`radio-button ${state.formData.is_international_applicant === 1 ? 'selected':''}`} onClick={()=>{updateForm('is_international_applicant', 1)}}></div>
                  <div className={`radio-label`} onClick={()=>{updateForm('is_international_applicant', 1)}}>Yes</div>
                </div>
                <div className={`radio-options`}>
                  <div className={`radio-button ${state.formData.is_international_applicant === 0 ? 'selected':''}`} onClick={()=>{updateForm('is_international_applicant', 0)}}></div>
                  <div className={`radio-label`} onClick={()=>{updateForm('is_international_applicant', 0)}}>No</div>
                </div>
              </div>
              {state.is_international_applicantValid === false && <div className="field-error">Must select an option.</div>}
            </div>

            <div className="input-group">
              <div className="field-label">Is English a Second Language for you? *</div>
              <div className="inline-radio">
                <div className={`radio-options`}>
                  <div className={`radio-button ${state.formData.is_english_second === 1 ? 'selected':''}`} onClick={()=>{updateForm('is_english_second', 1)}}></div>
                  <div className={`radio-label`} onClick={()=>{updateForm('is_english_second', 1)}}>Yes</div>
                </div>
                <div className={`radio-options`}>
                  <div className={`radio-button ${state.formData.is_english_second === 0 ? 'selected':''}`} onClick={()=>{updateForm('is_english_second', 0)}}></div>
                  <div className={`radio-label`} onClick={()=>{updateForm('is_english_second', 0)}}>No</div>
                </div>
              </div>
              {state.is_english_secondValid === false && <div className="field-error">Must select an option.</div>}
            </div>

            <div className="input-group">
              <div className="field-label">Are you a US Citizen?</div>
              <div className="inline-radio">
                <div className={`radio-options`}>
                  <div className={`radio-button ${state.formData.is_citizen === 1 ? 'selected':''}`} onClick={()=>{updateForm('is_citizen', 1)}}></div>
                  <div className={`radio-label`} onClick={()=>{updateForm('is_citizen', 1)}}>Yes</div>
                </div>
                <div className={`radio-options`}>
                  <div className={`radio-button ${state.formData.is_citizen === 0 ? 'selected':''}`} onClick={()=>{updateForm('is_citizen', 0)}}></div>
                  <div className={`radio-label`} onClick={()=>{updateForm('is_citizen', 0)}}>No</div>
                </div>
              </div>
              {state.is_citizenValid === false && <div className="field-error">Must select an option.</div>}
            </div>
            <div className="input-group">
              <div className="field-label">Country of Residence</div>
              <select placeholder="Select your country of residence" value={state.formData.country_of_residence} onChange={(e)=>{updateForm('country_of_residence', e.target.value)}}>
                <option>Select Country</option>
                {allCountries.map(country => {
                  return <option key={country.sortname} value={country.sortname}>{country.name}</option>
                })}
              </select>
            </div>
          </div>
          <FormAction 
            isFormDataValid={state.isFormDataValid}
            formData={state.formData}
            formStep={'residency'}
            backStep={'contactInfo'}
            nextStep={'demographics'}
          />
      	</div>
    </>
    );
  }

export default Residency;
